"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelParsingOption = void 0;
/* eslint-disable no-unused-vars */
var ModelParsingOption;
(function (ModelParsingOption) {
    ModelParsingOption[ModelParsingOption["None"] = 0] = "None";
    ModelParsingOption[ModelParsingOption["RejectUndefinedExtensions"] = 1] = "RejectUndefinedExtensions";
    ModelParsingOption[ModelParsingOption["RejectNonDtmiContexts"] = 2] = "RejectNonDtmiContexts";
    ModelParsingOption[ModelParsingOption["MandateTopLevelPartition"] = 4] = "MandateTopLevelPartition";
    ModelParsingOption[ModelParsingOption["PermitAnyTopLevelElement"] = 8] = "PermitAnyTopLevelElement";
    ModelParsingOption[ModelParsingOption["ParseAllowsIdReferenceSyntax"] = 16] = "ParseAllowsIdReferenceSyntax";
    ModelParsingOption[ModelParsingOption["ResolveAllowsIdReferenceSyntax"] = 32] = "ResolveAllowsIdReferenceSyntax";
})(ModelParsingOption = exports.ModelParsingOption || (exports.ModelParsingOption = {}));
//# sourceMappingURL=modelParsingOption.js.map